import { compareIgnoreCase } from 'monaco-editor/esm/vs/base/common/strings.js';
function areSameExtensions(a, b) {
    if (a.uuid && b.uuid) {
        return a.uuid === b.uuid;
    }
    if (a.id === b.id) {
        return true;
    }
    return compareIgnoreCase(a.id, b.id) === 0;
}
function getExtensionId(publisher, name) {
    return `${publisher}.${name}`;
}
function adoptToGalleryExtensionId(id) {
    return id.toLowerCase();
}
export { adoptToGalleryExtensionId, areSameExtensions, getExtensionId };
